// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { StyledButton } from "@insite/mobius/Clickable";
import { StyledClickable } from "@insite/mobius/Link";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { footerContainerStyles } from "@stoneage/Overrides/Widgets/Footer/FooterContainer";
import { DivWrapper } from "@stoneage/XDL/constants";
import { fontConfig } from "@stoneage/XDL/constants";
import { color, layoutContainer, xScreen } from "@stoneage/XDL/Utilities";
import { css } from "styled-components";

footerContainerStyles.linkListGridItem = {
    width: [12, 12, 12, 4, 4],
    css: css`
        padding: 15px 11px;
    `,
};

footerContainerStyles.subscribeGridItem = {
    width: [12, 12, 12, 4, 4],
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

footerContainerStyles.subscribeContainer = {
    css: css`
        padding: 16px 16px 24px;
        border: 1px solid ${color("common.ui9")};
        border-bottom-width: 0;
        width: 100%;
        &:has(> div:empty) {
            border-color: transparent;
        }
        &:has(+ div > div:empty) {
            border-bottom-width: 1px;
        }
    `,
};

footerContainerStyles.podcastContainer = {
    css: css`
        width: 100%;
        border: 1px solid ${color("common.ui9")};
        &:has(> div:empty) {
            border-color: transparent;
        }
    `,
};

footerContainerStyles.socialLinksGridItem = {
    width: 12,
};

footerContainerStyles.siteMapLinksGridItem = {
    width: 12,
};

footerContainerStyles.richContentGridItem = {
    width: 12,
};

footerContainerStyles.mzGridItem = {
    width: [12, 12, 12, 8, 8],
};

footerContainerStyles.footerWrapper = {
    css: css`
        padding: 32px 34px 20px;
        ${xScreen("lte", "md")} {
            padding: 32px 24px 20px;
        }
        ${xScreen("lt", "sm")} {
            padding: 32px 16px 20px;
        }

        ${layoutContainer}
    `,
};

footerContainerStyles.linksWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-top: 64px;
    `,
};

footerContainerStyles.externalWrapper = {
    css: css`
        display: flex;
        flex-wrap: ${({ isInShell }: any) => (isInShell ? "nowrap" : "wrap")};
        align-items: end;
        gap: 16px 24px;

        ${StyledClickable},
        ${StyledButton} {
            &,
            ${TypographyStyle} {
                color: ${color("common.ui5")};
                font-size: ${fontConfig.xSmallSingleLine.size}px;
                line-height: ${fontConfig.xSmallSingleLine.lineHeight};
                font-weight: ${fontConfig.weight.regular};
                &:hover,
                &:focus {
                    color: ${color("primary.main")};
                }
            }
        }

        ${xScreen("lte", "md")} {
            width: 100%;
        }
    `,
};

footerContainerStyles.topWrapper = {
    css: css`
        border-bottom: 1px solid ${color("common.ui8")};
        margin-bottom: 2px;
        padding-bottom: 32px;
    `,
};

footerContainerStyles.midWrapper = {
    css: css`
        border-top: 1px solid ${color("common.ui8")};
        padding-top: 32px;
    `,
};
